import {notify} from '@gemcook/notification';

import api from '@api';
import constants from '@constants';

export const submit = async (
  email: string,
  id: string,
  setLoading: (loading: boolean) => void,
  actions: UsersAction,
  closeModal: any,
  history: any
) => {
  setLoading(true);
  try {
    await api.users.isLoginUsersUnique({email});
    const b: UserPostCognitoUser = {
      email,
    };

    const res = await api.users.createCognitoUser(b);

    const body: UserUpdateBody = {
      sub: res.sub,
      cognitoUserName: res.sub,
      authLevel: 1,
    };

    actions.users.updateUser(body, id);

    notify('ユーザー宛に管理者へ権限変更のメールを送信しました', 'success');

    closeModal();
    history.goBack();
  } catch (error) {
    switch (error.response.data.message) {
      case 'UsernameExistsException: An account with the given email already exists.':
        notify(constants.ERRORS.EXISTED_EMAIL, 'error');
        break;
      case 'An account with the given email already exists.':
        notify(constants.ERRORS.EXISTED_EMAIL, 'error');
        break;
      default:
        notify('管理者への変更に失敗しました', 'error');
        break;
    }
  } finally {
    setLoading(false);
  }
};
